















import {
    Component, Prop, Vue, Watch,
} from 'vue-property-decorator'
import { PropType } from 'vue'
import marked from 'marked'
import { TrelloCard } from '@/TrelloClient'
import CardDescription from '@/components/CardParts/CardDescription.vue'

@Component({
    components: {
        CardDescription,
    },
})
export default class extends Vue {
    get activeCard() {
        return this.$store.state.activeCard
    }
}
